import React from "react";
import PostAddForm from "../../../../components/forms/postItemsForm/index";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SuccessNotify } from "../../../../constants/tostify";
import { FailedNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { decodeId } from "../../../../utils/idObfuscator";
import { useGetShopByIdQuery } from "../../../../features/shop/shopApiSlice";
import { useNewItemsPostAdd } from "../../../../hooks/useNewItemsPostAdd";

const NewItemsPostAddForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [mygetitem, setMygetitem] = useState();
  const { name } = useSelector((state) => state.user);

  const {
    createShopItem,
    isCreatingItem,
    triggerGetCategories,
    triggerUserShops,
  } = useNewItemsPostAdd();

  const cleanShopId = decodeId(id) || id || "";
  const { data: shopRes } = useGetShopByIdQuery(cleanShopId, {
    skip: !cleanShopId,
  });
  const shop = shopRes?.data?.Shop;

  const [data, setData] = useState({
    category: "",
    subCategory: ""
  });

  useEffect(() => {
    const fromShop =
      shop?.shopCategory?.name ||
      shop?.shopCategory ||
      "";
    const fromStorage = localStorage.getItem('mycategory') || "";
    const resolved =
      (typeof fromShop === "string" && fromShop.trim()) ||
      (fromStorage && fromStorage !== "undefined" && fromStorage !== "null" && fromStorage.trim()) ||
      "";
    setMygetitem(resolved);
  }, [shop]);

  const Handledata = (e) => {
    const raw = e.target.value || "";
    const dot = raw.indexOf(".");
    let idPart = raw;
    let namePart = "";
    if (dot !== -1) {
      idPart = raw.slice(0, dot);
      namePart = raw.slice(dot + 1);
    }
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: [idPart, namePart]
    }));
  };

  const categoryName = data?.category[1];
  const categoryid = data.category[0];
  const subcategoryName = data?.subCategory[1];
  const subcategoryid = data.subCategory[0];

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setUserData((userData) => ({
        ...userData,
        images: abc
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [userData, setUserData] = useState({
    businessType: "retailerShop",
    userid: "",
    shopid: "",
    itemname: "",
    isSingleItem: false,
    isScrapItem: false,
    category: "",
    categoryid: "",
    subCategory: "",
    subCategoryid: "",
    price: "",
    country: "",
    city: "",
    state: "",
    quantity: "",
    description: "",
    unitOfMeasurement: "",
    salespromotion: "",
    specialoffer: "",
    currency: "",
    images: [""],
    status: true
  });

  useEffect(() => {
    setUserData((userData) => ({
      ...userData,
      category: categoryName,
      categoryid: categoryid,
      subCategory: subcategoryName,
      subCategoryid: subcategoryid
    }));
  }, [categoryid, categoryName, subcategoryName, subcategoryid]);

  useEffect(() => {
    if (mygetitem) {
      triggerGetCategories({ type: "retailerShop", parentCategory: mygetitem })
        .unwrap()
        .then((response) => {
          if (response?.success) {
            setShopCategory(response?.data?.Category);
          }
        })
        .catch((error) => {
          console.log("servicesCategories", error);
        });
    }
  }, [mygetitem, triggerGetCategories]);

  useEffect(() => {
    if (categoryName) {
      triggerGetCategories({ type: "retailerShopItem", parentCategory: categoryName })
        .unwrap()
        .then((response) => {
          if (response?.success) {
            setShopCategorytwo(response?.data?.Category);
          }
        })
        .catch((error) => {
          console.log("servicesCategories", error);
        });
    } else {
      setShopCategorytwo([]);
    }
  }, [categoryName, triggerGetCategories]);

  const FirstCategory = () => {
    if (mygetitem) {
      triggerGetCategories({ type: "retailerShop", parentCategory: mygetitem })
        .unwrap()
        .then((response) => {
          if (response?.success) {
            setShopCategory(response?.data?.Category);
          }
        })
        .catch((error) => {
          console.log("servicesCategories", error);
        });
    }
  };

  const Mydata = () => {
    if (categoryName) {
      triggerGetCategories({ type: "retailerShopItem", parentCategory: categoryName })
        .unwrap()
        .then((response) => {
          if (response?.success) {
            setShopCategorytwo(response?.data?.Category);
          }
        })
        .catch((error) => {
          console.log("servicesCategories", error);
        });
    }
  };

  const userDatahandler = (e) => {
    e.preventDefault();
    createShopItem({
      ...userData,
      userid: userData.userid || shop?.userid?._id || shop?.userid || name?._id,
      shopid: userData.shopid || shop?._id || cleanShopId || id,
      country: userData.country,
      state: userData.state,
      city: userData.city,
      businessType: "retailerShop",
    })
      .unwrap()
      .then((response) => {
        if (response?.success) {
          setTimeout(() => {
            SuccessNotify("Add Post Successfully");
          }, 1000);
          navigate(`/NewItem-bussines-Profile/${id}`);
        }
      })
      .catch((e) => {
        FailedNotify("Failed To Post Try Again!");
      });
  };

  useEffect(() => {
    const resolvedUserId = shop?.userid?._id || shop?.userid || name?._id || "";
    const resolvedShopId = shop?._id || cleanShopId || id || "";
    if (!resolvedUserId && !resolvedShopId) return;

    const defaultCountry =
      shop?.resolvedCountry ||
      shop?.country ||
      shop?.userid?.address?.country ||
      shop?.userid?.country ||
      name?.address?.country ||
      name?.country ||
      "";
    const defaultState =
      shop?.resolvedRegion ||
      shop?.state ||
      shop?.userid?.address?.state ||
      shop?.userid?.state ||
      name?.address?.state ||
      name?.state ||
      "";
    const defaultCity =
      shop?.resolvedCity ||
      shop?.city ||
      shop?.userid?.address?.city ||
      shop?.userid?.city ||
      name?.address?.city ||
      name?.city ||
      name?.MCity ||
      "";

    setUserData((prev) => ({
      ...prev,
      userid: resolvedUserId || prev.userid,
      shopid: resolvedShopId || prev.shopid,
      country: prev.country || defaultCountry,
      state: prev.state || defaultState,
      city: prev.city || defaultCity,
    }));
  }, [shop, name, cleanShopId, id]);

  if (isloading || isCreatingItem) {
    return <Loader heightsetting="screenHeight" />;
  }

  return (
    <PostAddForm
      routename="/newitems-Postadd"
      back="/NewItem-bussines-Profile/"
      butn="Post"
      postbtn="/NewItem-bussines-Profile"
      cancel="/NewItem-bussines-Profile/"
      setUserData={setUserData}
      handlerFunction={userDatahandler}
      userData={userData}
      id={id}
      shopCategory={shopCategory}
      shopCategorytwo={shopCategorytwo}
      Mydata={Mydata}
      Handledata={Handledata}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      FirstCategory={FirstCategory}
      isUploading={isUploading}
      uploadProgress={uploadProgress}
    />
  );
};

export default NewItemsPostAddForm;
